// extracted by mini-css-extract-plugin
export default {"errorTemplate":"ErrorPage_errorTemplate__aEGwX","btn":"ErrorPage_btn__Mwm8M"};